module.exports = __webpack_public_path__ + "static/media/xls.b60460df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/xls.png
// module id = 78
// module chunks = 0